import { http } from './HttpService.js'
import { EventBus } from '@/services/EventBus'

export default {
	fetch(params = '') {
		http.get('configs' + params)
			.then(res => {
				for(let config of res.data) {
					localStorage.setItem('config_' + config.nome, config.valor)

					if(config.nome == 'modulo_contas') {
						EventBus.$emit('hasFinanceiro', config.valor)
					}

					if(config.nome == 'modulo_vendedor') {
						EventBus.$emit('hasVendedor', config.valor)
					}

					if(config.nome == 'modulo_categoria') {
						EventBus.$emit('moduloCategoria', config.valor)
					}

					if(config.nome == 'modulo_franquias') {
						EventBus.$emit('moduloVendaFranquia', config.valor)
					}

					if(config.nome == 'notas_robo') {
						EventBus.$emit('moduloRobo', config.valor)
					}

					if(config.nome == 'modulo_vendedor') {
						EventBus.$emit('moduloVendedores', config.valor)
					}

					if(config.nome == 'modulo_relatorio_usuario') {
						EventBus.$emit('moduloRelatorioUsuario', config.valor)
					}

					if(config.nome == 'modulo_telemetria') {
						EventBus.$emit('modulo_telemetria', config.valor)
					}
				}
			})
	},
}